Vue.component('bp-metadata-relation-resolver', {
    functional: true,
    name: "BpMetadataRelationResolver",
    props: {
        relationString: {
            type: String,
            default: '',
            required: true
        },
        metadataHandler: {
            type: Object,
            required: true,
        },
        placeholderHandler: {
            type: Object,
        },
        placeholders: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    render(createElement, { props, listeners, slots, data }) {
        let relation = props.relationString.split(':');

        let currentStep = relation.shift();

        if(currentStep === 'selection') {
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("bp-metadata-selection", {
                props: {
                    showClose: false,
                    metadataHandler: props.metadataHandler,
                    placeholderHandler: props.placeholderHandler,
                    relationString: leftOverRelationString,
                },
                on: {
                    updateMetadata: listeners['update-metadata'],
                    close: listeners['close']
                }
            });
        } else if( currentStep === 'metadata-form') {
            let currentMetadataId = relation.shift();
            let metadataIndex = relation.shift();
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("bp-metadata-form", {
                props: {
                    metadataId: currentMetadataId,
                    metadataHandler: props.metadataHandler,
                    placeholderHandler: props.placeholderHandler,
                    metadataIndex: metadataIndex,
                    placeholders: props.placeholders,
                    relationString: leftOverRelationString,
                },
                on: {
                    saved: listeners['saved'],
                    close: listeners['close']
                }
            });
        }
    }
}, false);
